<template>
  <v-card class="card-container">
    <div class="main-toolbar">
      <div class="icon-back">
        <v-img src="../../../assets/figmaIcons/white/standchecklist.svg" max-width="55%"></v-img>
      </div>
      <span class="main-toolbar-title">Base de conhecimento</span>
      <v-spacer></v-spacer>
    </div>

    <div class="mt-4">
      <v-card class="pa-4 mb-6">

        <div class="d-flex align-center justify-end" v-if="$vuetify.breakpoint.mdAndUp">
          <v-btn color="#0F3565" dark depressed class="hidden-sm-and-down primary-button" @click="openDialog">
            Adicionar conhecimento
          </v-btn>
          <v-btn class="ml-2 hidden-sm-and-down primary-button" color="#BBCF20" depressed dark
            @click="visible = !visible">
            {{ $t('Filtros') }}
          </v-btn>
        </div>

        <div class="d-flex justify-left back hidden-md-and-up mt-4">
          <v-btn color="#0F3565" dark depressed small class="hidden-md-and-up" @click="openDialog">
            <v-icon center>mdi-plus</v-icon>
          </v-btn>
          <v-btn small class="hidden-md-and-up ml-2 mb-2" color="#BBCF20" depressed dark @click="visible = !visible">
            <v-icon center>mdi-filter</v-icon>
          </v-btn>
        </div>

        <v-expand-transition>
          <div v-show="visible">
            <v-row class="ma-0" dense>
              <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
                <label class="label" for="searchQuery">{{ $t('Equipamento') }}</label>
                <v-text-field id="searchQuery" v-model="searchQuery" placeholder="Buscar conhecimento"
                  hide-details="auto" outlined class="primary-input" @keyup.enter="searchKnowledge"></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
                <label class="label" for="filterActive">{{ $t('Status') }}</label>
                <v-select id="filterActive" v-model="filterActive" :items="filterOptions" item-text="text"
                  item-value="value" placeholder="Selecione o status" hide-details="auto" height="46" outlined
                  background-color="#F5F5F5" class="primary-input" append-icon="mdi-chevron-down"
                  @change="applyFilter"></v-select>
              </v-col>
            </v-row>
          </div>
        </v-expand-transition>

        <!-- Desktop Wrapper -->
        <div class="wrapper desktop">
          <v-data-table :headers="headers" :items="knowledges" :loading="loading" :page.sync="page"
            :items-per-page="itemsPerPage" mobile-breakpoint="0" :server-items-length="totalItems" class="main-table"
            hide-default-footer hide-default-header v-model="selectedKnowledges" show-select>
            <template #header="{ props, on }">
              <thead>
                <tr v-if="props && props.headers">
                  <th class="text-center" :class="`col-${header.value}`" v-for="header in props.headers"
                    :key="header.value">
                    <div>
                      <v-hover v-slot="{ hover }">
                        <div>
                          <span>{{ header.text }}</span>
                          <v-icon v-if="hover && header.value != 'actions'" color="white" class="mx-2"
                            @click="on.sort(header.value)">
                            {{
                              props.options && props.options.sortBy && props.options.sortBy.includes(header.value)
                                ? `mdi-chevron-down`
                                : `mdi-chevron-up`
                            }}
                          </v-icon>
                        </div>
                      </v-hover>
                    </div>
                  </th>
                </tr>
              </thead>
            </template>

            <template #[`item.title`]="{ item }">
              {{ item.title }}
            </template>
            <template #[`item.content`]="{ item }">
              {{ item.content }}
            </template>
            <template #[`item.createdAt`]="{ item }">
              {{ new Date(item.createdAt).toLocaleDateString('pt-BR') }}
            </template>

            <template #[`item.actions`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small depressed class="ma-1" color="#0F3565" dark @click="editKnowledge(item)" v-bind="attrs"
                    v-on="on">
                    <v-icon dark small>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ma-1" small color="error" style="font-weight: bold" v-bind="attrs"
                    @click.stop="openDeleteDialog(item)" v-on="on" depressed>
                    <v-icon color="white">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('Excluir') }}</span>
              </v-tooltip>
            </template>

          </v-data-table>

          <div class="pagination">
            <div class="item-pagination block-one">
              <v-menu bottom offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" class="btn" depressed color="#C0C0C0" small>
                    qtd: {{ itemsPerPage }}
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(size, i) in sizes" :key="i" @click="setPageSize(size)">
                    <v-list-item-title>{{ size }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <div class="registros" v-if="totalItensOnPage">
                <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span> <br />
              </div>
            </div>

            <div class="item-pagination block-two">
              <v-pagination class="pagination-item" v-model="page" :length="totalPages"
                :total-visible="3"></v-pagination>
            </div>
          </div>
        </div>


        <!-- Mobile Wrapper -->
        <div class="wrapper mobile">

          <v-data-table :headers="headersMobile" :items="knowledges" :loading="loading" :page.sync="page"
            :items-per-page="itemsPerPage" mobile-breakpoint="330" :server-items-length="totalItems" class="main-table"
            hide-default-footer hide-default-header v-model="selectedKnowledges">
            <template #header="{ props, on }">
              <thead>
                <tr v-if="props && props.headers">
                  <th class="text-center" :class="`col-${header.value}`" v-for="header in props.headers"
                    :key="header.value">
                    <div>
                      <v-hover v-slot="{ hover }">
                        <div>
                          <span>{{ header.text }}</span>
                          <v-icon v-if="hover && header.value != 'actions'" color="white" class="mx-2"
                            @click="on.sort(header.value)">
                            {{
                              props.options && props.options.sortBy && props.options.sortBy.includes(header.value)
                                ? `mdi-chevron-down`
                                : `mdi-chevron-up`
                            }}
                          </v-icon>
                        </div>
                      </v-hover>
                    </div>
                  </th>
                </tr>
              </thead>
            </template>

            <template #[`item.title`]="{ item }">
              {{ item.title }}
            </template>

            <template #[`item.content`]="{ item }">
              {{ item.content }}
            </template>

            <template #[`item.createdAt`]="{ item }">
              {{ new Date(item.createdAt).toLocaleDateString('pt-BR') }}
            </template>

            <template #[`item.actions`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small depressed class="ma-1" color="#0F3565" dark @click="editKnowledge(item)" v-bind="attrs"
                    v-on="on">
                    <v-icon dark small>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ma-1" small color="error" style="font-weight: bold" v-bind="attrs"
                    @click.stop="openDeleteDialog(item)" v-on="on" depressed>
                    <v-icon color="white">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('Excluir') }}</span>
              </v-tooltip>
            </template>
          </v-data-table>

          <div class="pagination">
            <div class="item-pagination block-one">
              <v-menu bottom offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" class="btn" depressed color="#C0C0C0" small>
                    qtd: {{ itemsPerPage }}
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(size, i) in sizes" :key="i" @click="setPageSize(size)">
                    <v-list-item-title>{{ size }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <div class="registros" v-if="totalItensOnPage">
                <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span> <br />
              </div>
            </div>

            <div class="item-pagination block-two">
              <v-pagination class="pagination-item" v-model="page" :length="totalPages"
                :total-visible="3"></v-pagination>
            </div>
          </div>
        </div>
      </v-card>
    </div>

    <!-- Diálogo para adicionar conhecimento desktop -->

    <v-dialog v-model="dialog" max-width="900px" v-if="$vuetify.breakpoint.mdAndUp">
      <v-card class="pa-4" outlined>
        <div class="d-flex py-2 align-center">
          <v-spacer></v-spacer>
          <h3 class="dialog-title-add">Adicionar conhecimento</h3>
          <v-spacer></v-spacer>
          <v-btn icon absolute top right @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider class="my-4"></v-divider>
        <v-form @submit.prevent="createKnowledge" class="dialog-form">
          <v-row class="ma-0">
            <v-col cols="12">
              <label for="formTitle">Título</label>
              <v-text-field id="formTitle" v-model="form.title" placeholder="Digite o titulo do conhecimento" required
                outlined background-color="#F5F5F5" class="primary-input" hide-details="auto"></v-text-field>
            </v-col>
            <v-col cols="12">
              <label for="formContent">Conteúdo</label>
              <v-textarea id="formContent" v-model="form.content" placeholder="Digite o conteúdo do conhecimento"
                required outlined background-color="#F5F5F5" class="primary-input" hide-details="auto"></v-textarea>
            </v-col>
            <v-col cols="12">
              <label for="formType">Tipo</label>
              <v-select id="formType" v-model="form.type" :items="knowledgeTypes" item-text="text" item-value="value"
                placeholder="Selecione o tipo de conhecimento" required outlined background-color="#F5F5F5"
                class="primary-input" hide-details="auto"></v-select>
            </v-col>
            <v-col cols="12">
              <label for="formStatus">Status</label>
              <v-select id="formStatus" v-model="form.isActive" :items="[
                { text: 'Ativo', value: true },
                { text: 'Inativo', value: false }
              ]" item-text="text" item-value="value" :rules="[(v) => v !== null || 'Status é obrigatório']"
                placeholder="Selecione o status" hide-details="auto" height="45" append-icon="mdi-chevron-down" outlined
                background-color="#F5F5F5" class="primary-input"></v-select>
            </v-col>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn class="secondary-button" depressed dark @click="dialog = false">Cancelar</v-btn>
              <v-btn type="submit" class="ml-3 primary-button" depressed dark>Adicionar</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Diálogo para adicionar conhecimento mobile -->
    <v-dialog v-model="dialog" max-width="100vw" persistent v-if="$vuetify.breakpoint.smAndDown"
      transition="dialog-bottom-transition">
      <v-card class="pa-2" outlined color="#fff">
        <div style="display: flex; justify-content: flex-end;">
          <v-btn icon @click="dialog = false" style="margin-right: 8px;">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div style="padding: 0 8px;">
          <h3 class="dialog-title-add"
            style="text-align: center; width: 100%; display: block; margin-top: 8px; margin-bottom: 8px;">
            Adicionar conhecimento
          </h3>
        </div>
        <v-divider class="my-2"></v-divider>
        <v-form @submit.prevent="createKnowledge" class="dialog-form-mobile">
          <v-row class="ma-0">
            <v-col cols="12" style="margin-bottom: 0px;">
              <label for="formTitleMobile">Título</label>
              <v-text-field id="formTitleMobile" v-model="form.title" placeholder="Digite o titulo do conhecimento"
                required outlined background-color="#F5F5F5" class="primary-input" hide-details="auto"
                style="font-size: 15px; margin-bottom: 0;"></v-text-field>
            </v-col>
            <v-col cols="12" style="margin-bottom: 0px;">
              <label for="formContentMobile">Conteúdo</label>
              <v-textarea id="formContentMobile" v-model="form.content" placeholder="Digite o conteúdo do conhecimento"
                required outlined background-color="#F5F5F5" class="primary-input" hide-details="auto"
                style="font-size: 15px; margin-bottom: 0;"></v-textarea>
            </v-col>
            <v-col cols="12" style="margin-bottom: 0px;">
              <label for="formTypeMobile">Tipo</label>
              <v-select id="formTypeMobile" v-model="form.type" :items="knowledgeTypes" item-text="text"
                item-value="value" placeholder="Selecione o tipo de conhecimento" required outlined
                background-color="#F5F5F5" class="primary-input" hide-details="auto"
                style="font-size: 15px; margin-bottom: 0;"></v-select>
            </v-col>
            <v-col cols="12" style="margin-bottom: 0px;">
              <label for="formStatusMobile">Status</label>
              <v-select id="formStatusMobile" v-model="form.isActive" :items="[
                { text: 'Ativo', value: true },
                { text: 'Inativo', value: false }
              ]" item-text="text" item-value="value" :rules="[(v) => v !== null || 'Status é obrigatório']"
                placeholder="Selecione o status" hide-details="auto" height="45" append-icon="mdi-chevron-down" outlined
                background-color="#F5F5F5" class="primary-input" style="font-size: 15px; margin-bottom: 0;"></v-select>
            </v-col>
            <v-col cols="12" class="d-flex justify-end">
              <div class="dialog-actions-mobile"
                style="display: flex; justify-content: flex-end; align-items: center; width: 100%; gap: 3px; margin-right: 21px;">
                <v-btn class="secondary-button" depressed dark @click="dialog = false">Cancelar</v-btn>
                <v-btn type="submit" class="ml-3 primary-button" depressed dark>Adicionar</v-btn>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Diálogo de confirmação de exclusão  desktop-->
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-sheet class="px-7 pt-7 pb-4 text-center w-100 rounded-lg" color="blue-grey darken-3" dark>
        <div class="grey--text text--lighten-1 text-body-2 mb-4">
          {{ $t('Tem certeza de que deseja excluir este item?') }}
        </div>

        <v-btn :disabled="loading" class="ma-1" color="grey" text @click="deleteDialog = false">
          Cancelar
        </v-btn>

        <v-btn :loading="loading" class="ma-1" color="error" text @click="confirmDeleteKnowledge">
          {{ $t('Excluir') }}
        </v-btn>
      </v-sheet>
    </v-dialog>

    <!-- Diálogo para editar conhecimento desktop -->
    <v-dialog v-model="editDialog" max-width="900px" v-if="$vuetify.breakpoint.mdAndUp">
      <v-card class="pa-4" outlined>
        <div class="d-flex py-2">
          <v-spacer></v-spacer>
          <h3 style="font-size: 2rem;">Editar conhecimento</h3>
          <v-spacer></v-spacer>
          <v-btn icon absolute top right @click="editDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider class="my-4"></v-divider>
        <v-form @submit.prevent="saveEditKnowledge" class="dialog-form">
          <v-row class="ma-0">
            <v-col cols="12">
              <label for="editFormTitle">Título</label>
              <v-text-field id="editFormTitle" v-model="editForm.title" placeholder="Digite o título do conhecimento"
                required outlined background-color="#F5F5F5" class="primary-input" hide-details="auto"></v-text-field>
            </v-col>
            <v-col cols="12">
              <label for="editFormContent">Conteúdo</label>
              <v-textarea id="editFormContent" v-model="editForm.content"
                placeholder="Digite o conteúdo do conhecimento" required outlined background-color="#F5F5F5"
                class="primary-input" hide-details="auto"></v-textarea>
            </v-col>
            <v-col cols="12">
              <label for="editFormType">Tipo</label>
              <v-select id="editFormType" v-model="editForm.type" :items="knowledgeTypes" item-text="text"
                item-value="value" placeholder="Selecione o tipo de conhecimento" required outlined
                background-color="#F5F5F5" class="primary-input" hide-details="auto"></v-select>
            </v-col>
            <v-col cols="12">
              <label for="editFormStatus">Status</label>
              <v-select id="editFormStatus" v-model="editForm.isActive" :items="[
                { text: 'Ativo', value: true },
                { text: 'Inativo', value: false }
              ]" item-text="text" item-value="value" :rules="[(v) => v !== null || 'Status é obrigatório']"
                placeholder="Selecione o status" hide-details="auto" height="45" append-icon="mdi-chevron-down" outlined
                background-color="#F5F5F5" class="primary-input"></v-select>
            </v-col>
            <v-col cols="12" class="d-flex align-center justify-space-between">
              <v-btn color="error" class="terciary-button" depressed dark @click="openDeleteDialog(editForm)">
                Excluir
              </v-btn>
              <div>
                <v-btn class="secondary-button" depressed dark @click="closeEditDialog">Cancelar</v-btn>
                <v-btn class="ml-3 primary-button" depressed dark type="submit">Salvar</v-btn>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Diálogo para editar conhecimento mobile -->
    <v-dialog v-model="editDialog" max-width="100vw" persistent v-if="$vuetify.breakpoint.smAndDown"
      transition="dialog-bottom-transition">
      <v-card class="pa-2" outlined color="#fff">
        <div style="display: flex; justify-content: flex-end;">
          <v-btn icon @click="editDialog = false" style="margin-right: 8px;">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div style="padding: 0 8px;">
          <h3 class="dialog-title-add"
            style="text-align: center; width: 100%; display: block; margin-top: 8px; margin-bottom: 8px;">
            Editar conhecimento
          </h3>
        </div>
        <v-divider class="my-2"></v-divider>
        <v-form @submit.prevent="saveEditKnowledge" class="dialog-form-mobile">
          <v-row class="ma-0">
            <v-col cols="12" style="margin-bottom: 0px;">
              <label for="editFormTitleMobile">Título</label>
              <v-text-field id="editFormTitleMobile" v-model="editForm.title"
                placeholder="Digite o título do conhecimento" required outlined background-color="#F5F5F5"
                class="primary-input" hide-details="auto" style="font-size: 15px; margin-bottom: 0;"></v-text-field>
            </v-col>
            <v-col cols="12" style="margin-bottom: 0px;">
              <label for="editFormContentMobile">Conteúdo</label>
              <v-textarea id="editFormContentMobile" v-model="editForm.content"
                placeholder="Digite o conteúdo do conhecimento" required outlined background-color="#F5F5F5"
                class="primary-input" hide-details="auto" style="font-size: 15px; margin-bottom: 0;"></v-textarea>
            </v-col>
            <v-col cols="12" style="margin-bottom: 0px;">
              <label for="editFormTypeMobile">Tipo</label>
              <v-select id="editFormTypeMobile" v-model="editForm.type" :items="knowledgeTypes" item-text="text"
                item-value="value" placeholder="Selecione o tipo de conhecimento" required outlined
                background-color="#F5F5F5" class="primary-input" hide-details="auto"
                style="font-size: 15px; margin-bottom: 0;"></v-select>
            </v-col>
            <v-col cols="12" style="margin-bottom: 0px;">
              <label for="editFormStatusMobile">Status</label>
              <v-select id="editFormStatusMobile" v-model="editForm.isActive" :items="[
                { text: 'Ativo', value: true },
                { text: 'Inativo', value: false }
              ]" item-text="text" item-value="value" :rules="[(v) => v !== null || 'Status é obrigatório']"
                placeholder="Selecione o status" hide-details="auto" height="45" append-icon="mdi-chevron-down" outlined
                background-color="#F5F5F5" class="primary-input" style="font-size: 15px; margin-bottom: 0;"></v-select>
            </v-col>
            <v-col cols="12" class="d-flex justify-end">
              <div class="dialog-actions-mobile"
                style="display: flex; justify-content: flex-end; align-items: center; width: 100%; gap: 3px; margin-right: 36px;">
                <v-btn class="secondary-button" depressed dark @click="editDialog = false">Cancelar</v-btn>
                <v-btn type="submit" class="ml-2 primary-button" depressed dark>Salvar</v-btn>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<style scoped lang="scss">
.mobile {
  display: none;

  @media (max-width: 960px) {
    display: block;
  }
}

.desktop {
  @media (max-width: 960px) {
    display: none;
  }
}

/* Remove borda e sombra apenas do v-card interno (base de conhecimento) */
.mt-4>.v-card.pa-4.mb-6 {
  box-shadow: none !important;
  border: none !important;
  background: transparent !important;
}

/* Largura das colunas para desktop */
@media (min-width: 961px) {
  .col-title {
    width: 30% !important;
    max-width: 30% !important;
    min-width: 120px;
  }

  .col-content {
    width: 50% !important;
    max-width: 50% !important;
    min-width: 180px;
  }

  .col-createdAt {
    width: 10% !important;
    max-width: 10% !important;
    min-width: 60px;
    text-align: center;
  }

  .col-actions {
    width: 10% !important;
    max-width: 10% !important;
    min-width: 60px;
    text-align: center;
  }
}

/* Largura das colunas para mobile */
@media (max-width: 960px) {
  .col-title {
    width: 20% !important;
    max-width: 20% !important;
    min-width: 120px;
  }

  .col-content {
    width: 50% !important;
    max-width: 50% !important;
    min-width: 180px;
  }

  .col-createdAt {
    width: 10% !important;
    max-width: 10% !important;
    min-width: 60px;
    text-align: center;
  }

  .col-actions {
    width: 20% !important;
    max-width: 20% !important;
    min-width: 60px;
    text-align: center;
  }
}

@media (max-width: 600px) {
  .wrapper.mobile {
    overflow-x: auto;
  }

  .main-table {
    font-size: 13px !important;
  }

  .main-table th,
  .main-table td {
    padding: 4px 6px !important;
    min-width: 90px !important;
    max-width: 180px !important;
    word-break: break-word;
  }

  .main-table .v-btn {
    min-width: 32px !important;
    height: 32px !important;
    font-size: 13px !important;
    padding: 0 4px !important;
  }

  .main-table .v-icon {
    font-size: 18px !important;
  }
}

/* Estilo para o dialog de adicionar conhecimento */
.dialog-card {
  border-radius: 16px;
  border: 1.5px solid #e0e0e0;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.08);
  padding: 0 0 16px 0;
}

.dialog-title,
.dialog-subtitle {
  width: 100%;
  text-align: center;
  display: block;
}

.dialog-title-add {
  width: 100%;
  text-align: center;
  display: block;
  margin-top: 0;
}

@media (max-width: 600px) {
  .dialog-title-add {
    margin-top: 32px;
    margin-bottom: 8px;
    position: relative;
    z-index: 1;
  }
}

.dialog-form {
  padding: 24px 32px 0 32px;
}

.dialog-input-border {
  border: 1.5px solid #e0e0e0;
  border-radius: 10px;
  padding: 20px 18px 10px 18px;
  margin-bottom: 18px;
  background: #fafbfc;
}

.dialog-input-border .v-text-field {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

.dialog-input-border .v-text-field:last-child {
  margin-bottom: 0 !important;
}

.search-align>>>.v-input__append-inner {
  display: flex;
  align-items: center;
  height: 100%;
}

// Delet card

.delete-confirm-card {
  border-radius: 14px;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.10);
  padding: 24px 0 28px 0; // mais espaço interno
  background: #fff;
  min-width: 400px; // aumenta o mínimo
  width: 100%; // ocupa toda a largura disponível do container
}

.delete-title {
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  color: #0F3565;
  margin-bottom: 32px;
}

.delete-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0px;
  padding: 0;
  margin-left: 20px;
}

.button {
  min-width: 110px;
  border-radius: 8px;
  font-weight: 600;
  text-transform: none;
}

.cancel-btn {
  background: #0F3565 !important;
  color: #FFFFFF !important;
}

.confirm-btn {
  background: #FF0000 !important;
  color: #ffffff !important;
}

// Edit actions
.edit-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.left-actions {
  display: flex;
  align-items: center;
}

.right-actions {
  display: flex;
  align-items: center;
  gap: 8px; // Espaço entre Cancelar e Salvar
}
</style>

<script>
import ApiService from '@/services/ApiService'
const apiService = new ApiService()

export default {
  data() {
    return {
      deleteDialog: false,
      deleteId: null,
      dialog: false,
      editDialog: false,
      loading: true,
      searchQuery: '',
      activeSearchQuery: '',
      page: 1,
      totalPages: 1,
      itemsPerPage: 10,
      sizes: [10, 20, 50],
      totalItems: 0,
      totalItensOnPage: 0,
      form: {
        title: '',
        content: '',
        type: '',
        isActive: true
      },
      editForm: {
        id: null,
        title: '',
        content: '',
        type: '',
        isActive: true
      },
      visible: false,
      filterActive: null,
      filterOptions: [
        { text: 'Todos', value: null },
        { text: 'Ativos', value: true },
        { text: 'Inativos', value: false }
      ],
      knowledges: [],
      selectedKnowledges: [],
      headers: [
        { text: 'Título', value: 'title', align: 'center' },
        { text: 'Conteúdo', value: 'content', align: 'center' },
        { text: 'Data', value: 'createdAt', align: 'center' },
        { text: 'Ações', value: 'actions', align: 'center', sortable: false }
      ],
      headersMobile: [
        { text: 'Título', value: 'title', align: 'center' },
        { text: 'Conteúdo', value: 'content', align: 'center' },
        { text: 'Data', value: 'createdAt', align: 'center' },
        { text: 'Ações', value: 'actions', align: 'center', sortable: false }
      ],
      knowledgeTypes: [
        { value: 0, text: 'Resposta de pergunta' }, // QuestionAnswer
        { value: 1, text: 'Regra de resposta' },    // ResponseRule
        { value: 2, text: 'Modelo de resposta' },   // ResponseTemplate
        { value: 3, text: 'Regra de negócio' },     // BusinessRule
        { value: 4, text: 'Documentação' },         // Documentation
        { value: 5, text: 'Tutorial' },             // Tutorial
        { value: 6, text: 'Guia de solução de problemas' } // TroubleshootingGuide
      ],
    }
  },
  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))

    await this.updateTable();
  },

  methods: {

    async getKnowledgeBasePaginated(filter = {}) {
      const url = `api/knowledgeBase/paginate`;

      const response = await apiService.get(
        url, filter,
        true,
        false
      );
      return response.content;
    },

    async updateTable() {
      this.loading = true;
      try {
        const query = {
          Query: this.activeSearchQuery || '',
          Page: this.page,
          PageSize: this.itemsPerPage
        };
        if (this.filterActive !== null) {
          query.IsActive = this.filterActive;
        }
        const paginatedData = await this.getKnowledgeBasePaginated(query);
        // Atualiza os dados da tabela e os valores de paginação conforme o backend retorna
        this.knowledges = Array.isArray(paginatedData.data)
          ? paginatedData.data
          : [];
        this.totalItems = paginatedData.pager?.totalItems || this.knowledges.length;
        this.totalItensOnPage = this.knowledges.length;
        this.totalPages = paginatedData.pager?.totalPages || 1;
      } catch {
      }
      this.loading = false;
    },

    async searchKnowledge() {
      if (!this.searchQuery || this.searchQuery.trim() === '') {
        this.activeSearchQuery = '';
        await this.updateTable();
        return;
      }
      this.loading = true;
      this.activeSearchQuery = this.searchQuery.trim();
      try {
        const query = {
          Query: this.activeSearchQuery || '',
          Page: this.page,
          PageSize: this.itemsPerPage
        };
        if (this.filterActive !== null) {
          query.IsActive = this.filterActive;
        }
        const paginatedData = await this.getKnowledgeBasePaginated(query);
        this.knowledges = Array.isArray(paginatedData.data)
          ? paginatedData.data
          : [];
        this.totalItems = paginatedData.pager?.totalItems || this.knowledges.length;
        this.totalItensOnPage = this.knowledges.length;
        this.totalPages = paginatedData.pager?.totalPages || 1;
      } catch (error) {
        console.error('Erro ao buscar conhecimento:', error);
      }
      this.loading = false;
    },

    async confirmDeleteKnowledge() {
      if (this.deleteId) {
        try {
          await apiService.delete(`api/knowledgeBase/${this.deleteId}`, true, false);
          this.deleteDialog = false;
          this.editDialog = false;
          await this.updateTable();
        } catch (error) {
          console.error('Erro ao deletar conhecimento:', error);
        }
      }
    },

    async saveEditKnowledge() {
      console.log('saveEditKnowledge - editForm:', this.editForm);
      if (
        this.editForm.title &&
        this.editForm.content &&
        this.editForm.type !== '' &&
        this.editForm.type !== null &&
        this.editForm.type !== undefined
      ) {
        const payload = {
          Title: this.editForm.title,
          Content: this.editForm.content,
          Type: this.editForm.type,
          IsActive: this.editForm.isActive
        };
        try {
          console.log('saveEditKnowledge - payload enviado:', payload);
          await this.updateKnowledge(this.editForm.id, payload);
          this.editDialog = false;
          await this.updateTable();
        } catch (error) {
          console.error('Erro ao editar conhecimento:', error);
          if (error && error.response) {
            console.error('Erro do backend:', error.response);
          }
        }
      } else {
        console.warn('saveEditKnowledge - editForm incompleto:', this.editForm);
      }
    },

    async createKnowledge() {
      this.loading = true;
      if (this.form.title && this.form.content && this.form.type !== null && this.form.type !== undefined) {
        // Monta o objeto conforme o backend espera
        const payload = {
          Title: this.form.title,
          Content: this.form.content,
          Type: this.form.type,
          IsActive: this.form.isActive !== undefined ? this.form.isActive : true,
        };

        // Envia para o backend
        try {
          await apiService.post(
            'api/knowledgeBase/create',
            payload,
            true,
            false
          );
          this.dialog = false;
          await this.updateTable();
        } catch (error) {
          console.error('Erro ao criar conhecimento:', error);
        }
        this.loading = false;
      }
    },

    async updateKnowledge(id, updatedData) {
      const payload = {
        Title: this.editForm.title,
        Content: this.editForm.content,
        Type: this.editForm.type,
        IsActive: this.editForm.isActive,
        UpdatedBy: this.userLogged?.id
      };
      console.log('updateKnowledge - payload:', payload);
      try {
        const response = await apiService.put(
          `api/knowledgeBase/${id}`,
          payload,
          true,
          false
        );
        console.log('updateKnowledge - resposta:', response);
        return response;
      } catch (error) {
        console.error('Erro ao atualizar conhecimento:', error);
        if (error && error.response) {
          console.error('Erro do backend:', error.response);
        }
        throw error;
      }
    },

    async getKnowledgeBase() {
      const response = await apiService.get(
        `api/knowledgeBase/`,
        true,
        false
      );
      return response.content;
    },

    async applyFilter() {
      this.page = 1;
      await this.updateTable();
    },

    setPageSize(size) {
      this.itemsPerPage = size;
      this.page = 1;
      this.updateTable();
    },

    openDialog() {
      this.dialog = true;
      this.form = { title: '', content: '', type: '', isActive: true };
    },

    closeEditDialog() {
      this.editDialog = false;
      this.deleteDialog = false;
    },

    editKnowledge(knowledge) {
      console.log('editKnowledge - knowledge recebido:', knowledge);
      console.log('editKnowledge - campos:', {
        id: knowledge.id,
        title: knowledge.title,
        content: knowledge.content,
        type: knowledge.type,
        isActive: knowledge.isActive
      });
      this.editForm = {
        id: knowledge.id || '',
        title: knowledge.title || '',
        content: knowledge.content || '',
        type: knowledge.type !== undefined && knowledge.type !== null ? Number(knowledge.type) : '',
        isActive: knowledge.isActive === true || knowledge.isActive === 'true' || knowledge.isActive === 1
      };
      console.log('editKnowledge - editForm preenchido:', this.editForm);
      this.editDialog = true;
    },

    openDeleteDialog(knowledge) {
      this.deleteId = knowledge.id;
      this.deleteDialog = true;
    },

  },

  watch: {
    page() {
      if (this.activeSearchQuery) {
        this.searchKnowledge();
      } else {
        this.updateTable();
      }
    },
    itemsPerPage() {
      if (this.activeSearchQuery) {
        this.searchKnowledge();
      } else {
        this.updateTable();
      }
    }
  },
}
</script>